<template>
  <b-card no-body class="mb-0">
    <b-tabs nav-class="mt-1" v-model="tab" justified card>
      <b-tab :title="`${get_collection_name(collection)} DETAILS`" title-link-class="font-weight-bold" no-body>
         <!-- <template v-slot:title>
          <div class="text-center px-3">
             {{collection}} Details</div>
         </template> -->
        <b-card class="mb-0">
          <customer-details
            :active="tab === 0"
            :filter="customerID"
            :nameS="name_" />
        </b-card>
      </b-tab>
      <!-- <b-tab title="Transaction History" title-link-class="font-weight-bold">
        <transaction-history
          type="transactions"
          :active="tab === 1"
          :filter="customerID" />
      </b-tab>
      <b-tab title="Loan History" title-link-class="font-weight-bold">
        <transaction-history
          type="loans"
          :active="tab === 1"
          :filter="customerID" />
      </b-tab>
      <b-tab title="Behaviour Insights" title-link-class="font-weight-bold" v-if="isBeta">
        Behaviour Insights
      </b-tab> -->
    </b-tabs>
  </b-card>
</template>

<script>
  import CustomerDetails from './CustomerDetails';
  import TransactionHistory from './TransactionHistory';
  import axios from 'axios';
  import {fullURL} from '../../utils';


  export default {
    name: 'TabView',

    components: {
      CustomerDetails,
      TransactionHistory
    },

    props: {
      id: {
        type: String,
        required: true
      },
      database:{
        type: String
      },
      collection:{
        type: String
      }
    },

    created() {
      axios.get(fullURL(`/360-view/${this.collection}/${this.id}`))
        .then(({data}) => {
          this.profile = data;
        })
        .catch(console.log);
    },

    data() {
      return {
        tab: 0,
        customerID: this.id,
        name_: this.collection,
        profile: null
        // customerID: "002b9fab-d35e-45ea-b322-d64e1e9a361c",
      };
    },
    methods:{
      remove_underscore(x){
          return x.replace("_", " ").toUpperCase();
      },

      get_collection_name(collection) {
        var collection_name = collection;
        if (collection.indexOf('.csv') > -1) {
          this.$store.state.files.fileList.forEach(file => {
          if (file.database === this.database && file._id === collection) {
              collection_name = file.originalName;
            }
          });
        }
        return collection_name.toUpperCase();
      }
    }
  };
</script>

<style scoped>

</style>
